import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../store/rootReducer';
import { toggleDarkmode, setDarkmode } from '../../store/appSlice';
import SunIcon from "../../assets/sun.svg?react";
import MoonIcon from "../../assets/moon.svg?react";

import "./DarkModeToggle.css";
import { useEffect, useState } from 'react';
import RealDarkMode from '../Stuff/RealDarkMode/RealDarkMode';

const DarkModeToggle = () => {
    const dispatch = useDispatch();
    const darkmode = useSelector((state: StoreState) => state.app.darkmode);
    const [realModeVisible, setRealModeVisible] = useState(false);

    const updateLocalStorage = (isDarkMode: boolean) => {
        localStorage.setItem('nfs_darkmode', JSON.stringify(isDarkMode));
    }

    const handleToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (event.ctrlKey && event.altKey) {
            setRealModeVisible(true);
        }
        dispatch(toggleDarkmode());
        updateLocalStorage(!darkmode);
        const body = document.body;
        if (body) {
            body.classList.toggle('dark', !darkmode);
            body.classList.toggle('light', darkmode);
        }
    };

    useEffect(() => {
        const savedMode = localStorage.getItem('nfs_darkmode');
        const isDarkMode = savedMode ? JSON.parse(savedMode) : false;

        // Set initial state from localStorage only on first render
        dispatch(setDarkmode(isDarkMode));

        // Set body classes based on current darkmode state
        const body = document.body;
        if (body) {
            body.classList.toggle('dark', isDarkMode);
            body.classList.toggle('light', !isDarkMode);
        }

        // If no saved preference, set default
        if (!savedMode) {
            updateLocalStorage(false);
        }
    }, []);

    return (
        <>
            <button className='dark-mode-button' onClick={handleToggle}>
                {darkmode ? <SunIcon /> : <MoonIcon />}
            </button>
            {realModeVisible &&
                <RealDarkMode />
            }
        </>
    );
};

export default DarkModeToggle;